import _extends from '@babel/runtime/helpers/extends';
import React, { useState, useRef, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import styles from './cta.scss.js';

const cx = classNames.bind(styles);

/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * This disable should be removed after actually fixing the issue
 */

const cta = InnerComponent => {
  const NewCta = props => {
    const {
      bgColor,
      fontColor,
      fontWeight,
      size,
      horizontalPadding,
      pill,
      focus,
      tabIndex = 0,
      autoFocus,
      iconBefore,
      iconAfter,
      linkClick,
      onFocusHandler,
      onBlurHandler,
      useEllipsis,
      isUnderlined,
      keepHover,
      type,
      onClick,
      onMouseDown,
      href,
      to,
      disabled = false,
      startFocused = false,
      shouldDisplayLayerTransparent = true,
      outlineColor,
      ...nativeProps
    } = props;

    // Keeps track of whether the component is currently in focus.
    const [isInFocus, setIsInFocus] = useState(false);
    const ref = useRef(null);

    /**
     * startFocusRef keep track of whether the component should be initially focused.
     * It is used in conjunction with the useLayoutEffect hook to determine if the component
     * should receive focus when it is mounted or updated.
     */
    const startFocusRef = useRef(false);
    const onFocus = event => {
      setIsInFocus(startFocusRef.current || event.target.matches(':focus-visible'));
      startFocusRef.current = false;
      onFocusHandler?.(event);
    };
    const onBlur = event => {
      setIsInFocus(false);
      onBlurHandler?.(event);
    };

    /**
     * Sets the initial focus on the component when it is mounted, if specified.
     */
    useLayoutEffect(() => {
      if (startFocused) {
        startFocusRef.current = true;
        ref.current?.focus?.();
      }
    }, [startFocused]);

    /**
     * Renders the CTA component as a button.
     */
    if (onClick || onMouseDown || type === 'submit') {
      const {
        className,
        ...buttonInnerProps
      } = props;
      return /*#__PURE__*/React.createElement("button", _extends({}, nativeProps, {
        className: cx(className, styles['cta-btn'], styles['np-base']),
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: e => !disabled && onClick?.(e),
        tabIndex: tabIndex,
        disabled: disabled,
        ref: ref
      }), /*#__PURE__*/React.createElement(InnerComponent, _extends({}, buttonInnerProps, {
        isInFocus: isInFocus
      })));
    }

    /**
     * Renders the CTA component as an anchor tag.
     */
    if (href) {
      const {
        ...anchorInnerProps
      } = props;
      return /*#__PURE__*/React.createElement("a", _extends({}, nativeProps, {
        tabIndex: tabIndex,
        target: nativeProps.target || '_self',
        className: cx(styles['cta-link'], styles['np-base']),
        onClick: linkClick,
        onFocus: onFocus,
        onBlur: onBlur,
        href: href,
        ref: ref
      }), /*#__PURE__*/React.createElement(InnerComponent, _extends({}, anchorInnerProps, {
        isInFocus: isInFocus
      })));
    }

    /**
     * Renders the CTA component as a link using React Router.
     */
    if (to) {
      const {
        ...linkInnerProps
      } = props;
      return /*#__PURE__*/React.createElement(Link, _extends({
        ref: ref
      }, nativeProps, {
        to: to,
        onClick: linkClick,
        onFocus: onFocus,
        onBlur: onBlur,
        tabIndex: tabIndex
      }), /*#__PURE__*/React.createElement(InnerComponent, _extends({}, linkInnerProps, {
        isInFocus: isInFocus
      })));
    }
    return /*#__PURE__*/React.createElement(InnerComponent, props);
  };
  return NewCta;
};

export { cta };
//# sourceMappingURL=cta.js.map
